import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { space } from '@core-ds/primitives';
import Heading from './heading';

const Container = styled.div`
   position: relative;
   display: flex;
   align-items: center;
   height: 100%;
   margin-left: ${space[5]};
   color: white;
   text-align: left;
`;

const Headings = ({ links, stores }) => {
   const [activeId, setActiveId] = useState(null);

   const headingOpened = useCallback(
      openedId => {
         setActiveId(activeId === openedId ? null : openedId);
      },
      [activeId, setActiveId]
   );

   return (
      <Container>
         {links.map(
            heading =>
               heading.disabled || (
                  <Heading
                     key={`${heading.title}-heading`}
                     info={heading}
                     isActive={activeId === heading.title}
                     headingOpened={headingOpened}
                     stores={stores}
                  />
               )
         )}
      </Container>
   );
};

export default Headings;
